module.exports = __webpack_public_path__ + "assets/img/recordIcon2.34bfe1d5.png";